<template>
        <div class="box">
            <inner-table id="innerLeave" ref="leaveList" :listviewurl="'student.leaveApplication.listAll'" :exclude-fields="'wfNodeNames'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
        </div>

</template>

<script>
export default {
    props: {
        vo: {}
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        onInnerCellClick() {

        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        },
        formatStatus(val) {
            if (val == 0) {
                return '待处理'
            } else if (val == 1) {
                return '已同意'
            } else if (val == 2) {
                return '已拒绝'
            }
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.status = this.formatStatus(v.status)
            })
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #999;
   padding-bottom: 1px;
}
</style>

